import { render } from "./good-items.vue?vue&type=template&id=3c030ab8&scoped=true"
import script from "./good-items.vue?vue&type=script&lang=js"
export * from "./good-items.vue?vue&type=script&lang=js"

import "./good-items.vue?vue&type=style&index=0&id=3c030ab8&lang=scss&scoped=true"

import exportComponent from "/home/hsf/.jenkins/workspace/mmm-overseas-prod-hongkong/rith-h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c030ab8"]])

export default __exports__